module.exports = __webpack_public_path__ + "static/img/leidabg.507a66a2.png";